import queryString from 'query-string';
import {REGISTRY_ITEM_GATEWAY_API_HOST} from '../constants/app';
import getMemberToken from '../utils/getMemberToken';

const RegistryItemGatewayApi = {
  getPurchases: async () => {
    const res = await fetch(`${REGISTRY_ITEM_GATEWAY_API_HOST}/purchases`, {
      method: 'GET',
      headers: {
        'membership-session-token': getMemberToken(),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });

    if (!res.ok) {
      const error = new Error(res.statusText);
      error.status = res.status;
      throw error;
    }

    const jsonResponse = await res.json();

    return jsonResponse;
  },

  updatePurchase: async ({memberId, purchaseId, item}) => {
    const res = await fetch(
      `${REGISTRY_ITEM_GATEWAY_API_HOST}/${memberId}/purchases/${purchaseId}`,
      {
        method: 'PATCH',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'MEMBERSHIP-SESSION-TOKEN': getMemberToken(),
        },
        body: JSON.stringify(item),
      },
    );

    if (!res.ok) {
      const error = new Error(res.statusText);
      error.status = res.status;
      throw error;
    }

    return res.json();
  },

  getRegistryItems: async ({
    memberId,
    registryStatusFilter = 'active',
    showCash = false,
    offset,
    sort = null,
    price = [],
    stores = '',
    status = undefined,
    types = [],
    limit = null,
    sortUnavailable = 'bottom',
    showGiftCards = true,
  }) => {
    if (!memberId) {
      throw new Error(
        'RegistryItemGatewayApi.getRegistryItems requires a memberId',
      );
    }

    let hasPurchases;
    let available;
    let fulfilled;
    if (status === 'purchased') {
      hasPurchases = true;
    } else if (status === 'available') {
      available = true;
      fulfilled = false;
    } else if (status === 'out of stock') {
      available = false;
    }

    const headers = new Headers();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');

    const options = {
      method: 'GET',
    };

    const isSorted = sort && sort.property && sort.direction;
    const qs = queryString.stringify({
      memberId,
      showCash,
      registryStatusFilter,
      showGiftCards,
      offset: offset > 0 ? offset : undefined,
      sort: isSorted ? `${sort.property}-${sort.direction}` : undefined,
      priceRange: price ? price.join(',') : undefined,
      fulfilled,
      available,
      hasPurchases,
      types: types ? types.join(',') : undefined,
      stores: stores.split('|').join(','),
      limit: limit || undefined,
      sortUnavailable,
    });

    const url = `${REGISTRY_ITEM_GATEWAY_API_HOST}/items?${qs}`;
    const res = await fetch(url, {headers, ...options});

    if (!res.ok) {
      const error = new Error(res.statusText);
      error.status = res.status;
      throw error;
    }

    const jsonResponse = await res.json();

    return jsonResponse;
  },

  getSummary: async ({priceRanges, registryId}) => {
    const qs = queryString.stringify({
      priceRanges,
      registryId,
    });

    const res = await fetch(`${REGISTRY_ITEM_GATEWAY_API_HOST}/summary?${qs}`, {
      method: 'GET',
      headers: {
        'membership-session-token': getMemberToken(),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });

    if (!res.ok) {
      const error = new Error(res.statusText);
      error.status = res.status;
      throw error;
    }

    const jsonResponse = await res.json();

    return jsonResponse;
  },

  getGiftAdvisorSummary: async ({registryId, numberOfGuests}) => {
    const qs = queryString.stringify({
      registryId,
      numberOfGuests,
    });

    const res = await fetch(
      `${REGISTRY_ITEM_GATEWAY_API_HOST}/gift-advisor-summary?${qs}`,
      {
        headers: {
          'membership-session-token': getMemberToken(),
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      },
    );

    if (!res.ok) {
      const error = new Error(res.statusText);
      error.status = res.status;
      throw error;
    }

    const jsonResponse = await res.json();

    return jsonResponse;
  },

  updateRegistryItem: async ({memberId, itemId, item}) => {
    const res = await fetch(
      `${REGISTRY_ITEM_GATEWAY_API_HOST}/${memberId}/registry-items/${itemId}`,
      {
        method: 'PATCH',
        headers: {
          'MEMBERSHIP-SESSION-TOKEN': getMemberToken(),
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(item),
      },
    );

    if (!res.ok) {
      const error = new Error(res.statusText);
      error.status = res.status;
      throw error;
    }

    const jsonResponse = await res.json();

    return jsonResponse;
  },

  deleteRegistryItem: async ({memberId, itemId}) => {
    const res = await fetch(
      `${REGISTRY_ITEM_GATEWAY_API_HOST}/${memberId}/registry-items/${itemId}`,
      {
        method: 'DELETE',
        headers: {
          'MEMBERSHIP-SESSION-TOKEN': getMemberToken(),
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      },
    );

    if (!res.ok) {
      const error = new Error(res.statusText);
      error.status = res.status;
      throw error;
    }

    return true;
  },
};

export default RegistryItemGatewayApi;
